import { Identifiable, Task } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { calculateAdvancement } from "../../utils/calculateAdvancement";

function unCheckedTask(task: Identifiable<Task>, nextTask: Identifiable<Task>) {
  return (
    (task.percentComplete === 100 && nextTask.percentComplete === 0) ||
    (task.status.percentComplete === 100 &&
      nextTask.status.percentComplete !== 100)
  );
}

function editTask(
  task: Identifiable<Task>,
  nextTask: Task,
): Identifiable<Task> {
  const mergedTask = {
    ...task,
    name: nextTask.name,
    description: nextTask.description,
    startDate: nextTask.startDate,
    endDate: nextTask.endDate,
    createdDate: nextTask.createdDate,
    completionDate: nextTask.completionDate,
    percentComplete: nextTask.percentComplete,
    status: nextTask.status,
    tags: nextTask.tags,
    activityKeyRank: nextTask.activityKeyRank,
    statusKeyRank: nextTask.statusKeyRank,
    duration: nextTask.duration,
    allocations: nextTask.allocations || task.allocations,
    lastModified: nextTask.lastModified,
    attributes: {
      ...task.attributes,
      ...nextTask.attributes,
    },
  };

  return !unCheckedTask(task, mergedTask)
    ? mergedTask
    : {
        ...task,
        ...mergedTask,
        allocations: task.allocations.map((allocation) => ({
          ...allocation,
          percentComplete: 0,
        })),
      };
}

function handleEditRequest(
  task: Identifiable<Task>,
  { nextTask, task: t }: Boundaries["editTask"]["request"],
): Identifiable<Task> {
  return t.uuid === task.uuid
    ? calculateAdvancement(editTask(task, nextTask))
    : task;
}

function handleEditSuccess(
  task: Identifiable<Task>,
  nextTask: Boundaries["editTask"]["success"],
): Identifiable<Task> {
  const impactedTask = nextTask.impactedElements
    ? nextTask.impactedElements.find(({ uuid }) => uuid === task.uuid)
    : undefined;

  return task.uuid === nextTask.uuid
    ? calculateAdvancement(editTask(task, nextTask))
    : !!impactedTask
      ? calculateAdvancement(editTask(task, { ...task, ...impactedTask }))
      : task;
}

function handleEditFailure(
  task: Identifiable<Task>,
  { task: t }: Boundaries["editTask"]["failure"],
): Identifiable<Task> {
  return t.uuid === task.uuid ? t : task;
}

export { handleEditRequest, handleEditSuccess, handleEditFailure };
